module.exports = __webpack_public_path__ + "static/media/detail_petScan.4582f3d0.png";